import { Box, type BoxProps } from '@chakra-ui/react'

// The Field Green card: surface + 1px hairline + radii.md, deliberately NO shadow
// (spec §3.4 — only popover/modal shadows exist). Depth comes from the surface
// ladder and the border, never a drop shadow.
export function Card({ children, ...rest }: BoxProps) {
  return (
    <Box
      bg="surface"
      borderWidth="1px"
      borderColor="border"
      borderRadius="md"
      p={6}
      {...rest}
    >
      {children}
    </Box>
  )
}
